import React, { useState, useContext } from "react"
import { useStaticQuery, graphql } from "gatsby"

import {
  OverlayContainer,
  ImageTileContainer,
  VenueLabel,
  ActionLabel,
  SliderContainer,
} from "./solutions.imagetile.style"
import Img from "gatsby-image"
import styled from "styled-components"
import Slider from "react-slick"
import { UIContext } from "../shared/layout"

export default function ImageTilePresenter({
  onClick = id => {},
  carousel = false,
}) {
  const { malls, offices, stadiums, retail } = useStaticQuery(graphql`
    query {
      malls: file(relativePath: { eq: "0_HOMEPAGE/malls.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 345, maxHeight: 510, quality: 85) {
            ...GatsbyImageSharpFluid_withWebp_noBase64
          }
        }
      }
      offices: file(relativePath: { eq: "0_HOMEPAGE/offices.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 345, maxHeight: 510, quality: 85) {
            ...GatsbyImageSharpFluid_withWebp_noBase64
          }
        }
      }
      stadiums: file(relativePath: { eq: "0_HOMEPAGE/stadiums.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 345, maxHeight: 510, quality: 85) {
            ...GatsbyImageSharpFluid_withWebp_noBase64
          }
        }
      }
      retail: file(relativePath: { eq: "0_HOMEPAGE/retail.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 345, maxHeight: 510, quality: 85) {
            ...GatsbyImageSharpFluid_withWebp_noBase64
          }
        }
      }
    }
  `)

  const getImage = item => item.childImageSharp.fluid

  const {
    state: { clientLoaded },
  } = useContext(UIContext)

  return clientLoaded && carousel ? (
    <SliderContainer>
      <Slider dots>
        <ImageTile
          fluidImage={getImage(malls)}
          onClick={onClick}
          lightboxId="malls"
          text="Malls"
        />
        <ImageTile
          fluidImage={getImage(offices)}
          onClick={onClick}
          lightboxId="offices"
          text="Offices"
        />
        <ImageTile
          fluidImage={getImage(stadiums)}
          onClick={onClick}
          lightboxId="stadiums"
          text="Stadiums"
        />
        <ImageTile
          fluidImage={getImage(retail)}
          onClick={onClick}
          lightboxId="retail"
          text="Retail"
        />
      </Slider>
    </SliderContainer>
  ) : (
    <>
      <ImageTile
        fluidImage={getImage(malls)}
        onClick={onClick}
        lightboxId="malls"
        text="Malls"
      />
      <ImageTile
        fluidImage={getImage(offices)}
        onClick={onClick}
        lightboxId="offices"
        text="Offices"
      />
      <ImageTile
        fluidImage={getImage(stadiums)}
        onClick={onClick}
        lightboxId="stadiums"
        text="Stadiums"
      />
      <ImageTile
        fluidImage={getImage(retail)}
        onClick={onClick}
        lightboxId="retail"
        text="Retail"
      />
    </>
  )
}

export const ImageTile = styled(
  React.memo(
    ({
      text,
      fluidImage,
      className,
      href = null,
      lightboxId = "",
      onClick = x => x,
    }) => {
      /* In mobile safari, when you tap on the element it simulates both a mouseEnter/hover and click event, making it too easy to activate the link. This forces the user to interact with the element twice before the link is activated to prevent accidental triggering. */

      const [isHovered, setIsHovered] = useState(false)
      const [isLinkEnabled, setIsLinkEnabled] = useState(false)

      const onEnter = () => {
        setIsHovered(true)
        setTimeout(() => {
          setIsLinkEnabled(true)
        }, 500)
      }

      const onLeave = () => {
        setIsHovered(false)
        setIsLinkEnabled(false)
      }

      const onLinkClick = () => {
        if (isLinkEnabled) {
          //Simulate the mouse leaving so that if the user navigates back to the page the item isn't stuck open on mobile
          onLeave()
          onClick(lightboxId)
        }
      }

      return (
        <ImageTileContainer
          fluid={fluidImage}
          isActive={isHovered}
          onMouseEnter={onEnter}
          onMouseLeave={onLeave}
          onTouchCancel={onLeave}
          className={className}
        >
          <OverlayContainer
            href={href}
            onClick={onLinkClick}
            isActive={isHovered}
          >
            <div style={{ position: "relative" }}>
              <p>
                <VenueLabel>{text}</VenueLabel>
                <ActionLabel>View Project</ActionLabel>
              </p>
            </div>
          </OverlayContainer>
          <Img
            fluid={fluidImage}
            style={{
              position: "absolute",
              width: "100%",
              height: "100%",
            }}
            alt={text}
          />
        </ImageTileContainer>
      )
    }
  )
)``
